import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between p-3 relative border-white border-opacity-25" }
const _hoisted_2 = { class: "flex items-center font-audiowide" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex flex-col whitespace-nowrap ml-4 w-56 text-sm opacity-75" }
const _hoisted_5 = { class: "flex-1 whitespace-nowrap" }
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = {
  key: 1,
  class: ""
}
const _hoisted_8 = {
  key: 2,
  class: ""
}
const _hoisted_9 = {
  key: 3,
  class: ""
}
const _hoisted_10 = {
  key: 4,
  class: ""
}
const _hoisted_11 = {
  key: 5,
  class: ""
}
const _hoisted_12 = {
  key: 6,
  class: ""
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Approve ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Launch ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Withdraw ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Land ship ")
const _hoisted_17 = {
  key: 0,
  class: "transition absolute flex inset-0 bg-black bg-opacity-90 items-center justify-center text-red-500 font-audiowide"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-5 h-5 -ml-1 mr-2 inline",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M13 10V3L4 14h7v7l9-11h-7z"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Please connect to the correct network ")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 4,
  class: "absolute inset-0"
}
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"absolute inset-0 bg-black opacity-50\"></div><div class=\"absolute inset-0 flex items-center justify-center text-center text-red-500\"><svg class=\"animate-spin h-8 w-8 text-white\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z\"></path></svg></div>", 2)
const _hoisted_23 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.image,
        class: "h-16"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", null, _toDisplayString(_ctx.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.nft.isOnL1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Waiting approval"))
        : _createCommentVNode("", true),
      (_ctx.nft.isCandidateForL2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Ship ready for travelling to " + _toDisplayString(_ctx.config.l2NetworkLabel), 1))
        : _createCommentVNode("", true),
      (_ctx.nft.isInTransitToL2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Travelling to " + _toDisplayString(_ctx.config.l2NetworkLabel) + " (~5 minutes)", 1))
        : _createCommentVNode("", true),
      (_ctx.nft.isOnL2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Ship safely landed on " + _toDisplayString(_ctx.config.l2NetworkLabel), 1))
        : _createCommentVNode("", true),
      (_ctx.nft.isInGame)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Mining comeths"))
        : _createCommentVNode("", true),
      (_ctx.nft.isInTransitToL1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Coming back to " + _toDisplayString(_ctx.config.l1NetworkLabel) + " (~3 hours)", 1))
        : _createCommentVNode("", true),
      (_ctx.nft.isReadyToRedeem)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Ready to land on " + _toDisplayString(_ctx.config.l1NetworkLabel), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.nft.canApprove)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          onClick: _ctx.approve,
          enabled: _ctx.isApproveBtnEnabled,
          class: "bg-yellow-600 border-yellow-700 hover:bg-yellow-500 hover:border-yellow-600"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick", "enabled"]))
      : _createCommentVNode("", true),
    (_ctx.nft.canSend)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          onClick: _ctx.send,
          enabled: _ctx.isSendBtnEnabled
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick", "enabled"]))
      : _createCommentVNode("", true),
    (_ctx.nft.canWithdraw)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 2,
          onClick: _ctx.withdraw,
          loading: _ctx.loading,
          enabled: _ctx.isWithdrawBtnEnabled
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["onClick", "loading", "enabled"]))
      : _createCommentVNode("", true),
    (_ctx.nft.canRelease)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 3,
          onClick: _ctx.release,
          enabled: _ctx.isReleaseBtnEnabled
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["onClick", "enabled"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-300",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-150",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.isOnWrongNetwork)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
      : _createCommentVNode("", true),
    (_ctx.openWaitingModal)
      ? (_openBlock(), _createBlock(_component_WaitingModal, {
          key: 5,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openWaitingModal = false))
        }))
      : _createCommentVNode("", true)
  ]))
}